import { optionsToStrategy } from '@/common/utils/optionsToStrategy'

export const authenticationMethods = {
  password: "password",
  oauth: "oauth"
}

export const authenticationMethodOptions = [
  { label: 'Senha', value: authenticationMethods.password },
  { label: 'OAuth', value: authenticationMethods.oauth },
]

export const authenticationMethodStrategy = optionsToStrategy(authenticationMethodOptions)
